import { render, staticRenderFns } from "./ProtocolosDetalhes.vue?vue&type=template&id=2fe4e2ab&scoped=true&"
import script from "./ProtocolosDetalhes.vue?vue&type=script&lang=js&"
export * from "./ProtocolosDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4e2ab",
  null
  
)

export default component.exports